import {
  ModelConceptAttribute,
  ModelConceptAttributeData,
} from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { createModelConceptAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/createModelConceptAttribute';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setDomainsForAttributeModelData =
  (value: string, rangeIris: string[]) => (model: Model) => {
    const existingAttribute =
      model.modelData.attributesByIri[value] ||
      createModelConceptAttribute({ value });

    const domains = Object.fromEntries(
      rangeIris.map((rangeIri) => {
        const range: ModelConceptAttributeData = {
          value: rangeIri,
        };

        return [rangeIri, range];
      })
    );

    const updatedAttribute: ModelConceptAttribute = {
      ...existingAttribute,
      domains,
    };
    setDataProperty<ModelData>(model)(model.modelData, 'attributesByIri', {
      ...model.modelData.attributesByIri,
      [value]: updatedAttribute,
    });
  };
